import {Content} from "pdfmake/interfaces";
import {prometalLogoSvg} from "../img/logoImg";
import {primaryColor} from "../consts";

export const defPDFHeader: Content = {
    color: primaryColor,
    table: {
        heights: 36,
        widths: ['auto', '*', 'auto'],
        body: [
            [
                {
                    borderColor: ['', '', '', primaryColor],
                    border: [false, false, false, true],
                    svg: prometalLogoSvg,
                    margin: [20, 10, 20, 10],
                },
                {
                    borderColor: ['', '', '', primaryColor],
                    border: [false, false, false, true],
                    text: 'Модульная система стелажей',
                    fontSize: 14,
                    margin: [0, 10, 20, 10],
                },
                {
                    borderColor: ['', '', '', primaryColor],
                    border: [false, false, false, true],
                    margin: [20, 15, 20, 5],
                    text: '+7 (800) 550 90 07    |    prometal.ru',
                    noWrap: true,
                    alignment: 'right',
                    fontSize: 10,
                    bold: true
                }
            ],
        ]
    }
}
